import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './LanguageAcordionList.module.scss';
import { LanguageAcordionItem } from 'components';
import { IAppLanguageData } from 'modules/userApps/store/actions/saveDistributionInfo';

export interface ILanguageAcordionList extends HTMLAttributes<HTMLDivElement> {
  name: string;
  items: IAppLanguageData[];
  disabled?: boolean;
}

const LanguageAcordionList: FC<ILanguageAcordionList> = (props) => {
  const { name, items, className, disabled } = props;
  const rootClassName = classNames(styles.root, className);

  if (!items) return null;

  return (
    <div className={rootClassName}>
      {items.map((item, idx) => (
        <LanguageAcordionItem
          name={`${name}.${idx}`}
          className={styles.item}
          languageValue={item.language}
          key={item.language}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default LanguageAcordionList;
